import { render, staticRenderFns } from "./CardTotals.vue?vue&type=template&id=4738d362&scoped=true&"
import script from "./CardTotals.vue?vue&type=script&lang=js&"
export * from "./CardTotals.vue?vue&type=script&lang=js&"
import style0 from "./CardTotals.vue?vue&type=style&index=0&id=4738d362&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4738d362",
  null
  
)

export default component.exports